import "./Projects.css";
function Projects() {
  return (
    <div className="ProjectContainer">
      <div className="ProjectFlex">
        <p className="ProjectHeading">My Projects</p>
        <div className="ProjectCards">
        <div className="ProjectCard">
            <p className="CardRow1">2025</p>
            <p className="CardRow2">EcoCart</p>
            <p className="CardRow2-1">
              Ecocart is a dedicated e-commerce platform for sustainable products.
              </p>
            <p className="CardRow3">React | Firebase | CSS</p>
            <span className="CardRow4">
              <a href="https://ecom-ecocart11.vercel.app/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/Ecom-Ecocart/tree/master">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2024</p>
            <p className="CardRow2">Master Tutor</p>
            <p className="CardRow2-1">
              An online tutoring website to support online education.
            </p>
            <p className="CardRow3">React | Firebase | CSS</p>
            <span className="CardRow4">
              <a href="https://tanisharao2002.github.io/Mastertutor/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/Mastertutor">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2023</p>
            <p className="CardRow2">Library Management System</p>
            <p className="CardRow2-1">
              Online Cloud based Library which solves major offline library problems.
            </p>
            <p className="CardRow3">React | Firebase | CSS</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/libraryManagement/signIn">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/libraryManagement">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2023</p>
            <p className="CardRow2"> Calendar</p>
            <p className="CardRow2-1">
              Personalised Calendar to organize your tasks.
            </p>
            <p className="CardRow3">React | Firebase | CSS</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/calendarapp/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/calendarapp">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2023</p>
            <p className="CardRow2">ChatGroup</p>
            <p className="CardRow2-1">
              An Open Chat Group wherever we all can interact.
            </p>
            <p className="CardRow3">React | Firebase | CSS</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/chatGroup/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/chatGroup">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2023</p>
            <p className="CardRow2">Weather App</p>
            <p className="CardRow2-1">
              Displays weather of the location using API
            </p>
            <p className="CardRow3">React | CSS | API</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/WeatherApp/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/WeatherApp">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2022</p>
            <p className="CardRow2">Tic Tac Toe</p>
            <p className="CardRow2-1">
              Simple game made in React | Learning steps!
            </p>
            <p className="CardRow3">React</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/tictactoe/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/tictactoe">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2022</p>
            <p className="CardRow2">Dogify</p>
            <p className="CardRow2-1">
              Dogs make us happy!! Click 
            </p>
            <p className="CardRow3">HTML | CSS | API</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/dogify/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/dogify">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2022</p>
            <p className="CardRow2">Switch Button</p>
            <p className="CardRow2-1">
              My learning steps, building dynamic webpage using JS.
            </p>
            <p className="CardRow3">HTML | CSS | JS</p>
            <span className="CardRow4">
            <a href="https://switchbutton.vercel.app/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/switchButton">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2022</p>
            <p className="CardRow2">Calculator</p>
            <p className="CardRow2-1">
              Small steps, this time basic Calculator.
            </p>
            <p className="CardRow3">HTML | CSS</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/calculator/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/calculator">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2021</p>
            <p className="CardRow2">Google Mail Login Page Clone</p>
            <p className="CardRow2-1">
              Practicing my CSS skills by developing exisiting pages.
            </p>
            <p className="CardRow3">HTML | CSS</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/Login-Page/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/Login-Page">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
          <div className="ProjectCard">
            <p className="CardRow1">2021</p>
            <p className="CardRow2">Revolution</p>
            <p className="CardRow2-1">
              Revolution of Earth around Sun. My interest in solar system made me develop this.
            </p>
            <p className="CardRow3">HTML | CSS</p>
            <span className="CardRow4">
            <a href="https://tanisharao2002.github.io/Revolution/">
                <button className="LiveBtn">Live Demo 🔗 </button>
              </a>
              <a href="https://github.com/Tanisharao2002/Revolution">
                <button className="SrcBtn">Source Code 💻</button>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
